import React from 'react';
import { Grid, Box, Typography, Divider, Chip, Stack } from '@mui/material';
import FormSectionHeader from '../../../components/common/FormSectionHeader';
import { sa, PillButton } from '../../../components/superAdminUi';

const Fact = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
    <Typography variant="body2" sx={{ fontFamily: sa.font.family, color: sa.color.textGray }}>{label}</Typography>
    <Typography variant="body2" sx={{ fontFamily: sa.font.family, fontWeight: sa.font.semibold, color: sa.color.text }}>{value || '—'}</Typography>
  </Stack>
);

const sectionTitleSx = {
  mb: 1,
  fontFamily: sa.font.family,
  fontWeight: sa.font.bold,
  color: sa.color.text,
};

// Step 3: read-only recap. The Create action lives in the wizard footer; on success this
// swaps to a confirmation panel offering the redirect and the "Save & add another" prefill.
export default function ReviewStep({ values, matId, groupName, created, onPrimaryNav, onSaveAnother }) {
  const products = values.products || [];

  if (created) {
    return (
      <Box sx={{ p: 3, textAlign: 'center', fontFamily: sa.font.family }}>
        <Typography variant="h6" sx={{ mb: 1, fontFamily: sa.font.family, fontWeight: sa.font.bold, color: sa.color.text }}>
          School added successfully
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, fontFamily: sa.font.family, color: sa.color.textGray }}>
          {values.Name} has been created{matId ? ` under ${groupName || 'the group'}` : ''}.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <PillButton type="button" $size="lg" onClick={onPrimaryNav}>
            {matId ? 'Go to group' : 'Go to school list'}
          </PillButton>
          <PillButton type="button" $variant="outline" $size="lg" onClick={onSaveAnother}>
            Save &amp; add another
          </PillButton>
        </Stack>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormSectionHeader title="Review & create" first />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={sectionTitleSx}>School</Typography>
        <Fact label="Name" value={values.Name} />
        <Fact label="URN" value={values.Urn} />
        <Fact label="Type" value={values.SchoolType} />
        <Fact label="Country" value={values.Country} />
        <Fact label="Pupils" value={values.NumberOfPupil} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={sectionTitleSx}>Subscription</Typography>
        <Fact label="Term" value={values.SubscriptionTerm ? `${values.SubscriptionTerm} year(s)` : '—'} />
        <Fact label="VAT" value={`${values.VatPercentApplied || 0}%`} />
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ mb: 0.5, fontFamily: sa.font.family, color: sa.color.textGray }}>Products</Typography>
          <Stack direction="row" spacing={0.5} flexWrap="wrap">
            {products.length === 0 ? (
              <Typography variant="body2" sx={{ fontFamily: sa.font.family }}>—</Typography>
            ) : (
              products.map((product) => <Chip key={product} size="small" label={product} />)
            )}
          </Stack>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ my: 1 }} />
      </Grid>
    </Grid>
  );
}
